<template>
  <div>
    <el-row type="flex" align="middle">
      <el-col>
        <h1>{{computedTitle}}</h1>
      </el-col>
      <el-col class="text_right">
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'page-title',
    props: ['title'],
    computed: {
      computedTitle() {
        if (this.title) {
          return this.title
        }
        return this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PageTitle/index.vue